import { useState, useEffect } from 'react';
import { fetchAuthSession, signOut } from '../../../utils/authSession';
import Cookies from 'js-cookie';

export const useAdminAuth = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkSession = async () => {
      setIsLoading(true);
      try {
        const session = await fetchAuthSession();
        const accessToken = session.tokens?.accessToken;
        const groups = accessToken?.payload?.["cognito:groups"] || [];
        const convaiadmin_accessToken = Cookies.get("accessToken");

        if (
          groups.includes("ConvAI_Admin") &&
          convaiadmin_accessToken === accessToken.toString()
        ) {
          setIsAuthenticated(true);
        } else {
          Cookies.remove("accessToken");
          await signOut();
          setIsAuthenticated(false);
        }
      } catch (err) {
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };
    checkSession();
  }, []);

  return { isLoading, isAuthenticated };
};